import { FileUploader } from "react-drag-drop-files";
import { Download, Loader2, UploadCloud } from "lucide-react";

interface CsvDropzoneProps {
  fileName: string | null;
  onFileSelected: (file: File) => void;
  uploading?: boolean;
  matchedCount?: number;
  unmatchedCount?: number;
  onDownloadTemplate: () => void;
  downloadingTemplate?: boolean;
}

export default function CsvDropzone({
  fileName,
  onFileSelected,
  uploading,
  matchedCount,
  unmatchedCount,
  onDownloadTemplate,
  downloadingTemplate,
}: CsvDropzoneProps) {
  return (
    <div>
      <button
        type="button"
        onClick={onDownloadTemplate}
        disabled={downloadingTemplate}
        className="mb-[8px] inline-flex items-center gap-[4px] text-[12px] font-medium text-[#734792] hover:underline disabled:opacity-60"
      >
        {downloadingTemplate ? (
          <Loader2 className="size-[12px] animate-spin" />
        ) : (
          <Download className="size-[12px]" />
        )}
        {downloadingTemplate ? "Downloading…" : "Download template"}
      </button>
      <FileUploader
        handleChange={(file: File | File[]) =>
          onFileSelected(Array.isArray(file) ? file[0] : file)
        }
        name="csv-user-list"
        types={["CSV"]}
      >
        <div className="flex flex-col items-center justify-center gap-[8px] rounded-[8px] border-2 border-dashed border-[#E4E4E7] bg-[#FAFAFA] py-[32px] text-center cursor-pointer">
          {uploading ? (
            <Loader2 className="size-[24px] text-[#734792] animate-spin" />
          ) : (
            <UploadCloud className="size-[24px] text-[#A1A1AA]" />
          )}
          <p className="text-[14px] text-[#1E1E1E]">
            {uploading
              ? "Uploading…"
              : fileName
                ? fileName
                : "Drop CSV or click to browse"}
          </p>
          <p className="text-[12px] text-[#A1A1AA]">
            One user ID per row - max 500,000 users
          </p>
        </div>
      </FileUploader>
      {!uploading && fileName && matchedCount !== undefined && (
        <p className="mt-[8px] text-[13px] text-[#16A34A]">
          {matchedCount} user{matchedCount === 1 ? "" : "s"} matched
          {!!unmatchedCount &&
            `, ${unmatchedCount} email${unmatchedCount === 1 ? "" : "s"} didn't match an existing user`}
        </p>
      )}
    </div>
  );
}
